module.exports = __webpack_public_path__ + "static/media/navigation-darker.712a61b9.png";